module.exports = __webpack_public_path__ + "img/OverseaMember13.b6056210.jpg";